import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const Auth0Icon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M11.5033 12.3261L10.1649 8L13.6697 5.32609C14.5321 8.10145 13.6697 10.6739 11.5033 12.3261ZM13.6697 5.32609L12.3313 1H7.99853L9.33008 5.32609H13.6697ZM7.99853 1H3.66581L2.33426 5.32609H6.66698L7.99853 1ZM2.32736 5.32609C1.47185 8.10145 2.32736 10.6739 4.49372 12.3261L5.82527 8L2.32736 5.32609ZM4.49372 12.3261L7.99853 15L11.5033 12.3261L7.99853 9.65217L4.49372 12.3261Z"
		></path>
	</svg>
))
